import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, NgZone, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { NavigationService } from '../../core/services/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { OroService } from '../../oroservice';
import { FileService } from '../../file.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { MediDialogComponent, DialogType } from '../../medi-dialog/medi-dialog.component';
import { Observable } from 'rxjs';
import moment from 'moment';

export class TitleMapItems {
    Level2: string = "";
    Level3: string = "";
    hasLevel3: boolean = false;
}

type DossierItem = {
    Key: string;
    Value: string | number;
}


interface Rate {
    Betrag?: number;
    Datum?: string;
}

interface Forderung {
    Betrag?: number | null;
    Grundforderung?: number;
    Teilzahlung?: number;
    Id?: number;
    Referenz?: string;
    Zahldatum?: string | Date | null;
}

interface RatenplanModel {
    AnzahlRaten?: number;
    Betrag?: number;
    CalcParameter?: number;
    Datenliste?: unknown[];
    ErsteRate?: moment.MomentInput;
    Gesamtbetrag?: number;
    Info?: string;
    InfoErsteRate?: string;
    InfoGesamtbetrag?: string;
    IsValid?: boolean;
    MonatlicheRate?: number | null;
    MonatlicheRaten?: number;
    PayTax?: boolean;
    Raten?: Rate[];
    Title?: string;
    Vereinbart?: boolean;
    Zinsen?: number;
}

interface DossierInfo {
    Abgerechnet?: boolean;
    Auftraege?: Forderung[];
    Betrag?: number;
    CanCreateDirektzahlungsmeldung?: boolean;
    CanCreateRatenplan?: boolean;
    CanRequestUeberzahlung?: boolean;
    eroeffnungsdatum?: moment.Moment;
    Forderungsgruende?: string;
    Id?: number;
    IsRechtlich?: boolean;
    Kunde?: string;
    NextFaelligkeit?: string;
    Ratenplan?: RatenplanModel;
    Restschuld?: number;
    RestschuldVonAnderenDossiers?: number;
    StartDatum?: string;
    Ueberzahlungsbetrag?: number;
}

interface DirektzahlungModel {
    ErrorVorEroeffnung?: boolean;
    Forderungen?: Forderung[];
}

interface UeberzahlungModel {
    Bank?: string;
    IBAN?: string;
    Kontoinhaber?: string;
}

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
    value: number = 4;
    isUpdating = false;
    chooseRatenplan = false;
    chooseDirektzahlung = false;
    chooseUeberzahlung = false;
    Ratenplan: RatenplanModel = {};
    Direktzahlung: DirektzahlungModel = {};
    Datum: Object = {};
    ratenplanarray: RatenplanModel[] = [];
    dossierinfo: DossierInfo = {};
    isValid = true;
    _timeout: number | null = null;
    naechstefaelligkeit: string = "";
    zahlung: UeberzahlungModel = {};
    forderungAdd: Forderung = {};
    dossierDatasource: DossierItem[];
    ChangeRatesAmount: boolean = true;

    ratenplanDisplayedColumns: string[] = ['Datum', 'Betrag'];
    dossierDisplayedColumns: string[] = ['Key', 'Value'];
    
    constructor(
        private navigation: NavigationService,
        public oroservice: OroService,
        public fileservice: FileService,
        private translate: TranslateService, private route: ActivatedRoute,
        private cookieservice: CookieService, public lc: NgZone, private cdref: ChangeDetectorRef, public dialog: MatDialog) {}
    
    

    ngOnInit() {
        this.oroservice.Token = "";

        this.route.queryParams
            .subscribe(params => {
                const token = params.token;
                if (token) {
                    this.oroservice.Token = token;
                    this.oroservice.setLogin(this.oroservice.Token).then((object) => {
                        if (object) {
                            this.Calculate(true);
                            this.refresh();
                        }
                    })
                }
            });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    checkDirektzahlungsDatumZukunft(datum: string | Date | null): boolean {
        if (datum && datum === "") {
            return false;
        }

        return new Date().setHours(0, 0, 0, 0) < new Date(datum).setHours(0, 0, 0, 0);
    }

    checkDirektzahlungsVorEroefffnung(ford: Forderung): boolean {
        if (!ford.Zahldatum || !ford.Betrag || ford.Zahldatum === "") {
            return false;
        }

        // Compared by numeric value at runtime (Date/Moment valueOf); the casts only
        // satisfy TS's relational-operator check and are erased on emit.
        if ((ford.Zahldatum as unknown as number) < (this.dossierinfo.eroeffnungsdatum as unknown as number)) {
            //var fordOrigin = this.dossierinfo.Auftraege.find(o => o.Referenz == ford.Referenz);
            if (ford.Betrag > ford.Grundforderung) {
                return true;
            }
        }

        return false;
    }

    refresh(mode: number = 1) {
        this.oroservice.getDossierInfo().then(
            (object) => {
                this.dossierinfo = object as DossierInfo;
                this.dossierinfo.eroeffnungsdatum = moment(this.dossierinfo.StartDatum, 'DD.MM.YYYY');
                this.dossierinfo.Auftraege.forEach(element => {
                    element.Grundforderung = element.Betrag - element.Teilzahlung;
                });
                this.Direktzahlung.Forderungen = this.dossierinfo.Auftraege;
                this.Direktzahlung.Forderungen.forEach(element => {
                    element.Betrag = null;
                });
                this.oroservice.mode = mode;
                this.DossierToDataSource();
            }
        )
    }

    onFilterChangeRatenplan() {
        if (this.dossierinfo != null && this.dossierinfo.IsRechtlich) {
            this.openDialog("500px", "Startseite.WaehlenRatenplan", "Ratenplan.Betreibung", "OK", "", DialogType.Info);
            return;
        }
        this.chooseRatenplan = true;
        this.chooseDirektzahlung = false;
        this.chooseUeberzahlung = false;
        this.next();
    }

    onFilterChangeDirektzahlung() {

        if (this.dossierinfo.CanCreateDirektzahlungsmeldung)
        {
            this.chooseDirektzahlung = true;
            this.chooseRatenplan = false;
            this.chooseUeberzahlung = false;
            this.next();
        }
        else
        {
            this.openDialog("500px", "Direktzahlung.Warnungstitel", "Direktzahlung.Warnungsinfo", "OK", "", DialogType.Warning);
        }
    }

    onFilterChangeUeberzahlung() {
        if (this.dossierinfo.CanRequestUeberzahlung) {
            if (this.dossierinfo.RestschuldVonAnderenDossiers > 100) {
                this.openDialog("500px", "Ueberzahlung.Title", "Ueberzahlung.WarningOpenAmount", "OK", "", DialogType.Warning);
            } else {

                this.oroservice.uberzahlungRequest().then(
                    object => {
                        this.openDialog("500px", "Ueberzahlung.Title", "Ueberzahlung.Content", "OK", "", DialogType.Info);
                        this.dossierinfo.CanRequestUeberzahlung = false;
                    });
            }
        } else {
            this.openDialog("500px", "Ueberzahlung.Title", "Ueberzahlung.Warning", "OK", "", DialogType.Warning);
        }
    }

    Logout() {
        this.oroservice.setLogout();
        window.location.href = "/?Logout=1";
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }

    DossierToDataSource() {
        const hasRatenplan = this.dossierinfo?.Ratenplan;

        if (this.dossierinfo != null) {
            this.dossierDatasource = [];
            this.dossierDatasource.push({ Key: 'Dossier.Dossiernr', Value: this.dossierinfo.Id });

            if (hasRatenplan) {
                this.dossierDatasource.push({ Key: 'Dossier.Gläubiger', Value: this.dossierinfo.Kunde });
            } else {
                this.dossierDatasource.push({ Key: 'Dossier.Kunde', Value: this.dossierinfo.Kunde });
            }

            this.dossierDatasource.push({ Key: 'Dossier.Forderungsgruende', Value: this.dossierinfo.Forderungsgruende });
            this.dossierDatasource.push({ Key: 'Dossier.Betrag', Value: "CHF " + this.dossierinfo.Betrag.toFixed(2) });
            this.dossierDatasource.push({ Key: 'Dossier.Gezahlt', Value: "CHF " + (this.dossierinfo.Betrag - this.dossierinfo.Restschuld).toFixed(2) });
            this.dossierDatasource.push({ Key: 'Dossier.OffenerBetrag', Value: "CHF " + this.dossierinfo.Restschuld.toFixed(2) });

            if (hasRatenplan) {
                this.dossierDatasource.push({ Key: 'Dossier.Rate', Value: "CHF " + this.dossierinfo?.Ratenplan?.MonatlicheRate.toFixed(2) });
            }

            if (!this.dossierinfo.Abgerechnet && this.dossierinfo.NextFaelligkeit !== "01.01.0001") {
                this.dossierDatasource.push({ Key: 'Dossier.Faelligkeit', Value: this.dossierinfo.Abgerechnet ? "-" : this.GetNextFaelligkeit() });
            }

            if (hasRatenplan) {
                //this.dossierDatasource.push({ Key: 'Dossier.Zinsen', Value: this.dossierinfo?.Ratenplan?.Zinsen });
                this.dossierDatasource.push({ Key: 'Dossier.LetzteRate', Value: this.GetLetzteRate() });
                this.dossierDatasource.push({ Key: 'Dossier.Total', Value: this.SumRatenplan().toString() });
            }
        }
    }

    next() {

        console.log("mode: " + this.oroservice.mode);

        if (this.oroservice.mode === 1 && !this.chooseRatenplan && !this.chooseDirektzahlung && !this.chooseUeberzahlung) return;

        if (this.oroservice.mode === 0) {
            this.oroservice.setLogin(this.oroservice.Token).then((object) => {
                if (object) {
                    this.Calculate(true);
                    this.refresh();
                }
            })
            return;
        }

        if (this.oroservice.mode === 1) {
            this.Ratenplan = {};
            if (this.chooseRatenplan) {
                this.Calculate(true);
            }
            
            this.refresh(2);
            return;
        }

        if (this.oroservice.mode === 2) {
            if (this.isUpdating) {
                return;
            }
            
            if (this.chooseRatenplan) {
                if (!this.Ratenplan.IsValid || this.Ratenplan.Vereinbart) return;
                this.openDialog("500px", "Startseite.Ratenplanbestätigen", "Ratenplan.Confirm", "Ja", "Nein", DialogType.Question).subscribe(result => {
                    if (result) {
                        this.SaveRatenplan();
                        this.oroservice.mode = 1;
                    }
                });

                return;
            }
            if (this.chooseDirektzahlung) {
                if (this.fileservice.files.length === 0) {
                    this.openDialog("500px", "Startseite.KeinZahlungsnachweis", "Startseite.KeinZahlungsnachweisinfo", "Ja", "Nein", DialogType.Question).subscribe(result => {
                        if (!result) {
                            this.DirektzahlungSave();
                        }
                    });
                }
                else {
                    this.DirektzahlungSave();
                }

                return;
            }
            if (this.chooseUeberzahlung) {
                this.UeberzahlungSave();
                return;
            }
        }

    }

    back() {
        if (this.oroservice.mode === 0) return;
        if (this.chooseRatenplan) {
            this.ChangeRatesAmount = true;
        }
        this.oroservice.mode = this.oroservice.mode - 1;
    }

    UeberzahlungSave()  {
        this.oroservice.setUberzahlung(this.zahlung).then(
            object => {
                if (object instanceof HttpErrorResponse && object.status === 500) {
                    this.oroservice.mode = 1;
                }
            });
    }

    DirektzahlungSave() {
        if (this.isUpdating) {
            return;
        }

        let formdata = this.fileservice.getfiles();
        const json = JSON.stringify(this.Direktzahlung);
        formdata.append("direktzahlung", json);

        this.isUpdating = true;

        this.oroservice.saveDirektzahlung(formdata).then(
            object => {
                if (object instanceof HttpErrorResponse && object.status === 500) {
                    this.oroservice.mode = 1;
                    this.fileservice.files = [];
                    this.refresh();
                }

                this.isUpdating = false;
            }
        );
    }

    onDateChange(event: Date | string | null, ford: Forderung) {
        console.log('Date changed:', event);
        ford.Zahldatum = this.oroservice.ChangeDate(event);
      }

    Calculate(init: boolean) {
        let restschuld : number = this.dossierinfo?.Restschuld;

        if (this.ChangeRatesAmount) {
            this.Ratenplan.MonatlicheRate = 0;
        } else {
            if (!this.Ratenplan.MonatlicheRate) {
                // Keine Eingabe -> Wir machen nichts (evtl. eine Fehlermeldung)
                return;
            }
            
            if (this.Ratenplan.MonatlicheRate > restschuld) {
                this.openDialog("500px", "Achtung", "Ratenplan.RateTooBig", "OK", "", DialogType.Warning);
                this.Ratenplan.MonatlicheRate = null;
                return;
            }

            this.Ratenplan.AnzahlRaten = 0;
        }

        if (restschuld > 0)
        {
            this.oroservice.setRatenplan(this.Ratenplan).then(
                object => {
    
                    if (object instanceof HttpErrorResponse && object.status === 400) {
                        this.ratenplanarray = [];
                        this.Ratenplan = {};
                    } else {
                        this.ratenplanarray = object as RatenplanModel[];
                        if (init) {
                            this.Ratenplan = this.ratenplanarray[0].IsValid ? this.ratenplanarray[0] : this.ratenplanarray[1]; }
                        else {
                            if (this.ratenplanarray[0].IsValid) {
                                this.Ratenplan = this.ratenplanarray[0];
                            } else {
                                if (this.ratenplanarray[1] && this.ratenplanarray[1].MonatlicheRate) {
                                    this.Ratenplan = this.ratenplanarray[1];
                                }

                                if (this.ratenplanarray[0].AnzahlRaten > 24 && this.ChangeRatesAmount) {
                                    this.openDialog("500px", "Achtung", this.ChangeRatesAmount ? "Ratenplan.TooManyRates" : "Ratenplan.TooManyRates2", "OK", "", DialogType.Warning);
                                }
                                else if (this.ratenplanarray[0].MonatlicheRate < 50) {
                                    this.openDialog("500px", "Achtung", "Ratenplan.RateTooSmall", "OK", "", DialogType.Warning);
                                }
                                else if (this.ratenplanarray[0].AnzahlRaten > 24) {
                                    this.openDialog("500px", "Achtung", this.ChangeRatesAmount ? "Ratenplan.TooManyRates" : "Ratenplan.TooManyRates2", "OK", "", DialogType.Warning);
                                }
                                else if (!this.ChangeRatesAmount && this.ratenplanarray[0].MonatlicheRate > this.dossierinfo.Restschuld) {
                                    this.ratenplanarray[0].MonatlicheRate = null;
                                    this.openDialog("500px", "Achtung", "Ratenplan.OmeRateOnly", "OK", "", DialogType.Warning);
                                }
                                else if (this.ratenplanarray[0].AnzahlRaten === 1) {
                                    this.openDialog("500px", "Achtung", "Ratenplan.OmeRateOnly", "OK", "", DialogType.Warning);
                                }
                            }
                        }
                    }

                    this.GetNextFaelligkeit();
                }
            );
        } 
    }

    OnErsteRateChange() {
        this.Calculate(false);
    }

    changeratetext(event) {
        this.Ratenplan.AnzahlRaten = 0;
        this.Ratenplan.MonatlicheRate = event;
        this.ChangeRatesAmount = false;
    }

    changeanzahltext() {
        this.Ratenplan.MonatlicheRate = 0;
        this.ChangeRatesAmount = true;
    }

    onChangeAnzahl(event) {
        this._timeout = null;
        if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.lc.run(() => {
                this.Ratenplan.AnzahlRaten = event;
                this.Calculate(false);
            });
        }, 1000);
    }

    onChangeBetrag(event) {
        this._timeout = null;
        if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.lc.run(() => {
                this.Ratenplan.MonatlicheRaten = event;
                this.Calculate(false);
            });
        }, 1000);
    }

    SaveRatenplan() {
        if (this.isUpdating) {
            return;
        }
        
        // CalcParameter == 0 -> Anzahl
        // CalcParameter == 1 -> Monatliche Rate
        if (this.Ratenplan.CalcParameter === 0) {
            this.Ratenplan.MonatlicheRate = 0;
        } else {
            this.Ratenplan.AnzahlRaten = 0;
        }

        this.isUpdating = true;

        this.oroservice.saveRatenplan(this.Ratenplan).then(
            object => {
                this.isUpdating = false;
                this.Ratenplan = object as RatenplanModel;
                this.refresh();
            });
    }

    SumRatenplan() {
        if (this.isEmptyObject(this.dossierinfo.Ratenplan)) return null;
        let total = 0.00;
        this.dossierinfo.Ratenplan.Raten.forEach(element => {
            total = total + element.Betrag;
        });
        return total;
    }

    GetLetzteRate() {
        if (this.isEmptyObject(this.dossierinfo.Ratenplan)) return null;
        return this.dossierinfo.Ratenplan.Raten[this.Ratenplan.Raten.length - 1].Betrag;
    }

    GetNextFaelligkeit() {
        return this.dossierinfo.NextFaelligkeit;
    }

    isEmptyObject(obj) {
        return (obj === undefined || obj == null || obj && (Object.keys(obj).length === 0));
    }

    DownloadRatenplan() {
        this.oroservice.DownloadRatenplan(this.Ratenplan)
            .catch((error: unknown) => console.error('DownloadRatenplan => error:', error));
    }

    DirektZahlungAdd(ford: Forderung, index: number) {
        let forderungAdd: Forderung = {};
        forderungAdd = {};
        forderungAdd.Referenz = ford.Referenz;
        forderungAdd.Id = ford.Id;

        this.Direktzahlung.Forderungen.splice(index + 1, 0, forderungAdd);
    }

    DirektZahlungRemove(index: number) {
        this.Direktzahlung.Forderungen.splice(index, 1);
    }

    private IsDirektZahlungValid(): boolean {
        let retVal: boolean = true;

        if (this.fileservice.isFileTooBig) {
            retVal = false;
        }
        else {
            this.Direktzahlung.Forderungen.forEach(ford => {
                const n = Number(((String)(ford.Betrag)).replace(",", ".").replace("'", ""));
                if (Number.isNaN(n) || n < 1) {
                    retVal = false;
                }
    
                if (this.checkDirektzahlungsDatumZukunft(ford.Zahldatum)) {
                    retVal = false;
                }

                if (this.checkDirektzahlungsVorEroefffnung(ford)) {
                    retVal = false;
                }
            });
        }

        return retVal;
    }

    CanSubmit(): boolean {
        if (this.chooseDirektzahlung) {
            return this.IsDirektZahlungValid();
        }
        else if (this.chooseUeberzahlung) {
            return (this.zahlung.IBAN && this.zahlung.IBAN.length > 0 && this.zahlung.Bank && this.zahlung.Bank.length > 0
                && this.zahlung.Kontoinhaber && this.zahlung.Kontoinhaber.length > 0);
        }
        else {
            return true;
        }
    }

    getTitleMapsItems(index: number): TitleMapItems {
        let ret: TitleMapItems = new TitleMapItems();

        switch (index) {
            case 0: ret.Level2 = "Login.title";
                break;

            case 1: ret.Level2 = "Dossier.Title";
                break;

            case 2: ret.Level2 = "Dossier.Title";
                if (this.chooseDirektzahlung) {
                    ret.Level3 = "Dossier.Direktzahlung";
                    ret.hasLevel3 = true;
                }
                else if (this.chooseRatenplan) {
                    ret.Level3 = "Ratenplan.Title";
                    ret.hasLevel3 = true;
                }
                break;
        }

        return ret;
    }
}
